import api from './api'

// 手机号登录接口
export const loginAPI = (credentials) => {
  // 如果是刷新令牌请求
  if (credentials.refresh) {
    return api.post('/users/token/refresh/', {
      refresh: credentials.refresh
    })
  }
  
  // 普通登录请求
  return api.post('/users/login/', {
    phone: credentials.phone,
    password: credentials.password,
    tenant_id: credentials.tenant_id // 可选，选择特定租户时传入
  })
}

// 切换租户
export const switchTenantAPI = (tenantId) => {
  return api.post('/users/switch-tenant/', {
    tenant_id: tenantId
  })
}

// 获取可切换的租户列表
export const getAvailableTenantsAPI = () => {
  return api.get('/users/switch-tenant/')
}

// 切换门店
export const switchStoreAPI = (storeId) => {
  return api.post('/users/switch-store/', {
    store_id: storeId
  })
}

// 获取可切换的门店列表
export const getAvailableStoresAPI = () => {
  return api.get('/users/switch-store/')
}

// 获取指定门店的用户列表
export const getStoreUsersAPI = (storeId) => {
  return api.get('/users/users/store_users/', {
    params: { store_id: storeId }
  })
}

// 切换部门
export const switchDepartmentAPI = (departmentId) => {
  return api.post('/users/switch-department/', {
    department_id: departmentId
  })
}

// 获取可切换的部门列表
export const getAvailableDepartmentsAPI = () => {
  return api.get('/users/switch-department/')
}

// 获取用户信息
export const getUserInfoAPI = () => {
  return api.get('/users/me/')
}

// 刷新token
export const refreshTokenAPI = (refreshToken) => {
  return api.post('/users/token/refresh/', {
    refresh: refreshToken
  })
}

// 退出登录
export const logoutAPI = () => {
  return api.post('/users/logout/')
}

// 更新用户资料
export const updateUserProfileAPI = (profileData) => {
  return api.patch('/users/me/', profileData)
}

// 修改密码
export const changePasswordAPI = (passwordData) => {
  return api.post('/users/change-password/', passwordData)
}